import React, { useState } from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import TooltipComponent from '@/modules/common/components/TooltipComponent/TooltipComponent';
import { logout } from '@/utils/helper';
import { Button, Typography } from '@pw-tech/omni-ui';
import { LogOut } from 'lucide-react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { COUNSELLER_PHONE_NUMBER } from '@/modules/common/constants';
const Header = () => {
  const router = useRouter();
  const isMobileScreen = useIsMobile();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const handleTooltipToggle = () => {
    setIsTooltipOpen(!isTooltipOpen);
  };
  const handleTooltipClose = () => {
    setIsTooltipOpen(false);
  };
  return <div className="flex items-center justify-between py-4 md:py-6 h-[72px]" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/525403d7-6d6b-4086-add8-db0aaf98584e.svg" alt="pw-logo" width={160} height={40} onClick={() => router.push('/')} className="cursor-pointer" data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
      <div className="flex gap-2 sm:!gap-4">
        <TooltipComponent position="bottom" origin={isMobileScreen ? 'end' : 'center'} isOpen={isTooltipOpen} onClose={handleTooltipClose} labelChildren={<Button size={isMobileScreen ? 'small' : 'medium'} variant="lowFocus" className="!flex items-center border rounded-lg w-full" onClick={handleTooltipToggle}>
              <div className="flex items-center gap-2">
                <Typography variant="regular" component="p" className="flex justify-center !text-white bg-black rounded-full w-5 h-5 items-center">
                  ?
                </Typography>
                {isMobileScreen ? <></> : <Typography variant="regular" component="p" className="">
                    Get Help
                  </Typography>}
              </div>
            </Button>} bodyChildren={<Typography color="static-white" component="div" variant="small">
              If you have any queries or concerns, please reach out to us at
            </Typography>} footerChildren={<div className="flex flex-row gap-2">
              <Typography variant="tiny" className="p-1 !text-sm !text-black bg-white rounded-lg w-max">
                {isMobileScreen ? <a href={`tel:+91${COUNSELLER_PHONE_NUMBER}`} className="text-black no-underline">
                    +91-{COUNSELLER_PHONE_NUMBER}
                  </a> : `+91-${COUNSELLER_PHONE_NUMBER}`}
              </Typography>
              <Typography variant="tiny" className="p-1 !text-sm !text-black bg-white rounded-lg">
                <a href="mailto:support@pwioi.com" className="text-black no-underline">
                  support@pwioi.com
                </a>
              </Typography>
            </div>} showHeader showFooter data-sentry-element="TooltipComponent" data-sentry-source-file="Header.tsx" />
        <Button size={isMobileScreen ? 'small' : 'medium'} type="button" variant="lowFocus" onClick={() => {
        logout();
        router.push('/');
      }} className="hover:border hover:bg-gray-100" data-sentry-element="Button" data-sentry-source-file="Header.tsx">
          {isMobileScreen ? <LogOut size={16} /> : <div className="flex items-center gap-2">
              <LogOut size={16} />
              <Typography variant="regular" component="p">
                Logout
              </Typography>
            </div>}
        </Button>
      </div>
    </div>;
};
export default Header;